import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ChatIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 10V6C18 4.895 17.105 4 16 4H6C4.895 4 4 4.895 4 6V13.375C4 14.48 4.895 15.375 6 15.375H7.5V18L10 16.5M18 10H12C10.895 10 10 10.895 10 12V16.125C10 17.23 10.895 18.125 12 18.125H13.544C14.088 18.125 14.621 18.273 15.088 18.553L17.5 20V18.125H18C19.105 18.125 20 17.23 20 16.125V12C20 10.895 19.105 10 18 10Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

ChatIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ChatIcon);
